import React, { useEffect, useState } from 'react';
import { 
  Box, Typography, Paper, Stack, Divider, 
  Skeleton, Link, Avatar, Grid 
} from "@mui/material";
import { 
  Tag, User, DollarSign, Calendar, 
  FileText, Link as LinkIcon, Briefcase 
} from "lucide-react";

const apiUrl = process.env.REACT_APP_API_BASE_URL;

const PALETTE = {
  ice: "#C2EDF0",
  aqua: "#00C0CA",
  dark: "#22404D",
  slate: "#94A3B8",
  pearl: "#F4F7F9"
};

const DetalleGasto = ({ idGasto }) => {
  const [gasto, setGasto] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchGastos = async () => {
      setLoading(true);
      try {
        const response = await fetch(`${apiUrl}/Gasto/${idGasto}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'apiKey': localStorage.getItem("apiKey")
          }
        });
        if (response.ok) {
          const data = await response.json();
          setGasto(data);
        }
      } catch (error) {
        console.error('Error fetching gasto:', error);
      } finally {
        setLoading(false);
      }
    };

    if (idGasto) fetchGastos();
  }, [idGasto]);

  // Componente interno para las filas de datos
  const InfoRow = ({ icon: Icon, label, value, isLink, link }) => (
    <Stack direction="row" spacing={2} alignItems="center" sx={{ py: 1.5 }}>
      <Avatar sx={{ bgcolor: `${PALETTE.aqua}15`, color: PALETTE.aqua, width: 40, height: 40, borderRadius: '12px' }}>
        <Icon size={20} />
      </Avatar>
      <Box>
        <Typography variant="caption" sx={{ color: PALETTE.slate, fontWeight: 700, display: 'block', textTransform: 'uppercase', letterSpacing: 0.5 }}>
          {label}
        </Typography>
        {isLink ? (
          <Link href={link} target="_blank" sx={{ color: PALETTE.aqua, fontWeight: 800, textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}>
            Ver Comprobante
          </Link>
        ) : (
          <Typography variant="body1" sx={{ color: PALETTE.dark, fontWeight: 800 }}>
            {value || "---"}
          </Typography>
        )}
      </Box>
    </Stack>
  );

  if (loading) {
    return (
      <Box sx={{ p: 3 }}>
        <Skeleton variant="text" width="60%" height={40} sx={{ mb: 2 }} />
        <Skeleton variant="rectangular" height={300} sx={{ borderRadius: '24px' }} />
      </Box>
    );
  }

  return (
    <Box sx={{ p: { xs: 2, md: 4 }, bgcolor: 'transparent' }}>
      <Typography variant="h5" sx={{ fontWeight: 900, color: PALETTE.dark, mb: 4, textAlign: 'center' }}>
        Detalle del Gasto
      </Typography>

      <Paper 
        elevation={0} 
        sx={{ 
          p: 4, 
          borderRadius: '32px', 
          border: '1px solid rgba(0,0,0,0.05)',
          boxShadow: '0 10px 30px rgba(0,0,0,0.03)'
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <InfoRow icon={Briefcase} label="Programa" value={gasto?.nombrePrograma} />
            <Divider sx={{ opacity: 0.5 }} />
            <InfoRow icon={Tag} label="Rubro" value={gasto?.rubro} />
            <Divider sx={{ opacity: 0.5 }} />
            <InfoRow icon={User} label="Proveedor" value={gasto?.proveedor} />
            <Divider sx={{ opacity: 0.5 }} />
            <InfoRow icon={DollarSign} label="Importe" value={`${gasto?.importe} ${gasto?.moneda}`} />
          </Grid>

          <Grid item xs={12} md={6}>
            <InfoRow icon={FileText} label="Tipo de Gasto" value={gasto?.tipoGasto} />
            <Divider sx={{ opacity: 0.5 }} />
            <InfoRow icon={Calendar} label="Fecha" value={gasto ? new Date(gasto.fecha).toLocaleString() : ''} />
            <Divider sx={{ opacity: 0.5 }} />
            <InfoRow icon={FileText} label="Descripción" value={gasto?.descripcion} />
            <Divider sx={{ opacity: 0.5 }} />
            <InfoRow icon={LinkIcon} label="Comprobante" isLink link={gasto?.linkComprobante} />
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export default DetalleGasto;